<template>
  <div>
    <main-header/>
    <div class="aboutUs-bg">
      <nav-bar class="d-md-block d-none"/>
      <div class="container text-center">
        <div class="row">
          <div class="col-10 mx-auto mt-5">
            <h1 class="col-auto text-center border-bottom-title mb-6 primary-text">
              قوانین و مقررات انتشارات شاهکار قلم
            </h1>
            <div class="mt-5 font-16">{{ publiclyTitle }}</div>
            <div class="mt-3 font-16">{{ publiclyText }}</div>
          </div>
          <div class="col-10 mx-auto aboutUs-txt">
            <h2 class="col-auto text-center border-bottom-title mb-6 primary-text">
              بخش پذیرش اثر انتشارات شاهکار قلم
            </h2>
            <p class="text-right">
              شرایط و نحوه پذیرش اثر برای بررسی در انتشارات آفتاب گیتی و موسسه انتشاراتی شاهکار قلم
              <br/>
              <br/>
              شامل دو مؤسسه انتشاراتی آفتاب گیتی، شاهکار قلم(ناشر تخصصی کمک آموزشی و کتاب های ترجمه ) و  بر اساس
            </p>
            <ul class="text-right mr-5">
              <li>فقط آثار تایپ‌شده برای بررسی پذیرفته می‌شود.</li>
              <li>زمان تقریبی بررسی اثر حداقل 5 و حداکثر 10 روز کاری است.</li>
              <li>موسسه انتشاراتی آفتاب گیتی برای پذیرفتن یا نپذیرفتن آثار پیشنهادی بر اساس معیارها و ملاحظات خود تصمیم می‌گیرد.</li>
              <li>پذیرفته نشدن اثر لزوماً به معنای پایین بودن کیفیت آن نیست و انتشارات خود را ملزم به دادن توضیح یا انتقال نظر کارشناسان به مؤلف یا مترجم نمی‌داند.</li>
            </ul>

            <p class="text-right">
              برای بررسی آثار تألیفی در شاهکار قلم، لازم است متن کتاب رو حد اقل 20 صفحه برای انتشارات ارسال کنند تا در شورای بررسی انتشارات مورد تایید قرار بگیرد.
            </p>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
    <navigation-drawer :drawer="drawer"/>

  </div>
</template>

<script>
import MainHeader from "./mainHeader";
import Footer from "./Footer";
import NavBar from "./navBar";
import NavigationDrawer from "./navigationDrawer";

export default {
  name: "publicly",
  metaInfo() {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {NavigationDrawer, NavBar, Footer, MainHeader},
  data: () => ({
    publiclyTitle:'کلیه حقوق مادی و معنوی این وب سایت متعلق به انتشارات شاهکار قلم می باشد',
    publiclyText: '',
    drawer: false,
  })
}
</script>

<style scoped>

</style>
